module.exports = __webpack_public_path__ + "8e1cb7e635c12218810765ff69d99017.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room1/vorstadthirn-ohne-spruch.jpg
// module id = 228
// module chunks = 0